export default function formatNumber(nubmer: number| string| undefined) {
  if (!nubmer) {
    return ''
  }
  return nubmer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
